import * as React from 'react';
import { INTERNAL_SUPPORTED_EVENTS } from '~/common/helpers';
import { useManageLocale } from '~/common/hooks';

export const usePluginLocaleListener = () => {
  const { updateLocale } = useManageLocale();

  React.useEffect(() => {
    const handleLocaleUpdate = (event: Event) => {
      const { locale } = (event as CustomEvent<{ locale: string }>).detail;
      updateLocale(locale);
    };

    window.addEventListener(
      INTERNAL_SUPPORTED_EVENTS.UPDATE_LOCALE,
      handleLocaleUpdate,
    );

    return () => {
      window.removeEventListener(
        INTERNAL_SUPPORTED_EVENTS.UPDATE_LOCALE,
        handleLocaleUpdate,
      );
    };
  }, [updateLocale]);
};
